import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useMutation } from '@sopranodesign/pulse-hooks';
import {
  Flex,
  FormGroup,
  Label,
  Select,
  Button,
  useNotification
} from '@sopranodesign/pulse-components';

import { useBuilder, useCanvas } from '../../../../hooks/index';
import { duplicateStepTransition } from '../../../../api/index';
import { nodeType } from '../../../../PropTypes/index';
import Modal from '../../../Modal';

const describeTransition = transition => {
  return transition.description || `Transition to "${transition.destination.title}"`;
};

const DuplicateBranchModal = ({ node, handleClose }) => {
  const transitions = node.base.transitions;

  const [transitionId, setTransitionId] = useState(transitions[0].id);

  const { dispatch } = useBuilder();

  const { handleCanvasRender } = useCanvas();

  const { showSuccess } = useNotification();

  const duplicateBranch = useMutation({
    mutationFn: duplicateStepTransition,
    onSuccess: ({ data }) => {
      dispatch({
        type: 'DUPLICATE_BRANCH',
        stepId: node.id,
        newSteps: data.steps,
        transitionDetails: data.transition
      });
      handleCanvasRender();
      showSuccess('Successfully duplicated branch');
      handleClose();
    }
  });

  const handleSubmit = event => {
    event.preventDefault();

    duplicateBranch.mutate({ stepId: node.id, transitionId });
  };

  const options = transitions.map(transition => ({
    value: transition.id,
    label: describeTransition(transition)
  }));

  return (
    <Modal header="Duplicate branch" handleClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <Flex col pad>
          <FormGroup>
            <Label>Which branch would you like to duplicate?</Label>
            <Select
              aria-label="branch-select"
              options={options}
              value={options.find(option => option.value === transitionId)}
              onChange={option => setTransitionId(option.value)}
            />
          </FormGroup>
          <Flex right>
            <Button
              type="submit"
              loading={duplicateBranch.isPending}
              disabled={!transitionId}>
              Duplicate
            </Button>
          </Flex>
        </Flex>
      </form>
    </Modal>
  );
};

DuplicateBranchModal.propTypes = {
  node: nodeType.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default DuplicateBranchModal;
